import { Box, Card, CollapsableCard, TogglerCheckbox } from '@factorialco/deprecated-design-system'

interface Props {
  value: boolean
  disabled?: boolean
  title: string
  description?: string | string[]
  onChange: (value: boolean) => void
  checkboxAriaLabel?: string
  CollapsableContent?: React.ReactNode
}

export const SettingsToggle: React.FC<Props> = ({
  title,
  description,
  value,
  disabled,
  checkboxAriaLabel,
  CollapsableContent,
  onChange,
}) => {
  const descriptions = (Array.isArray(description) ? description : [description]).filter(Boolean)
  return (
    <CollapsableCard
      open={Boolean(value && CollapsableContent)}
      contentPadding="s16"
      Card={
        <Box onClick={disabled ? undefined : () => onChange(!value)} paddingX="s8" gap="s8">
          <Card.Title
            size="small"
            action={
              <TogglerCheckbox
                value={value}
                onChange={() => {}}
                disabled={disabled}
                aria-label={checkboxAriaLabel}
              />
            }
          >
            {title}
          </Card.Title>
          {descriptions.map((text) => (
            <Card.Description key={text}>{text}</Card.Description>
          ))}
        </Box>
      }
      Content={CollapsableContent ? <Box paddingX="s8">{CollapsableContent}</Box> : undefined}
    />
  )
}
